import { UIHeading6 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './Features.css';

export interface IFeaturesProps {
  features: string[];
}

export function Separator() {
  return <span className={styles['separator']}>•</span>;
}

export const Features: React.FC<IFeaturesProps> = props => {
  return (
    <div className={styles['container']}>
      {props.features.reduce((result, feature, index, { length }) => {
        const heading = (
          <span key={`feature_heading_${index}`} className={styles['heading-wrapper']}>
            <UIHeading6 display="inline-block" whiteSpace="nowrap">
              {feature}
            </UIHeading6>
          </span>
        );
        const separator = index < length - 1 && <Separator key={`feature_separator_${index}`} />;

        if (separator) {
          result.push(
            <React.Fragment key={`feature_wrapper_${index}`}>
              {heading}
              {separator}
            </React.Fragment>,
          );
        } else {
          result.push(heading);
        }

        return result;
      }, [] as React.ReactNode[])}
    </div>
  );
};
